<template>
  <div class="col routes-box">
    <div v-for="(address, index) in data.addresses"
         :key="`address-prefix-${index}`"
    >
      <div class="row mb-3">
        <div class="col-1 text-left"
             :class="{'border-h-animate' : index < data.addresses.length - 1}"
        >
          <i class="fa fa-circle"
             :class="[address.type_id === 1 ? 'c-pickup' : 'c-delivery']"
          />
        </div>
        <div class="col-12 col-md-11 col-lg-11 col-xl-11 addresses-wrap pl-0">
          <div class="row">
            <div class="col">
              <div class="row mb-1">
                <div class="col">
                  <div class="btn-group btn-group-toggle mb-2"
                       :class="{disabled: inactiveStatus || !hasAccess}"
                  >
                    <label class="btn"
                           :class="{'btn-primary': address.type_id === 1}"
                           @click="canSwitchRoute && (address.type_id = 1)"
                    >
                      <input type="radio"
                             name="options"
                             autocomplete="off"
                             :class="{disabled: inactiveStatus || !hasAccess}"
                             :disabled="inactiveStatus || !hasAccess"
                             checked
                             @click="toggleEditField"
                      /> Pickup
                    </label>
                    <label class="btn"
                           :class="[{'btn-primary': address.type_id === 2}, {disabled: inactiveStatus || !hasAccess}]"
                           @click="canSwitchRoute && (address.type_id = 2)"
                    >
                      <input
                        :class="{disabled: inactiveStatus || !hasAccess}"
                        :disabled="inactiveStatus || !hasAccess"
                        type="radio"
                        name="options"
                        autocomplete="off"
                        @click="toggleEditField"
                      />
                      Delivery
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-lg-6 col-md-6 col-xl-6 pr-3 pr-md-1 pr-lg-1 pr-xl-1 mb-2 mb-lg-0 mb-md-0 mb-xl-0">
              <div class="select-wrap">
                <label>{{ address.type_id === 1 ? 'Pickup address' : 'Delivery address' }}</label>
                <input v-model="address.full_address"
                       type="text"
                       class="form-control"
                       :disabled="inactiveStatus || !hasAccess"
                       @input="getAddressData(address.full_address, index)"
                       @keydown.prevent.down="$event.target.nextElementSibling && $event.target.nextElementSibling.firstChild.focus()"
                       @keyup="$emit('toggleEditField')"
                />
                <div class="dropdown-menu show address-field-wrap"
                     aria-labelledby="dropdownMenu2"
                     v-if="showDropdown[index] === true && addresses[index]"
                >
                  <button type="button"
                          class="dropdown-item"
                          v-for="(addressItem, indexAddr) in addresses[index]"
                          :key="`btn-prefix-${indexAddr}`"
                          @click="$emit('setAddress', addressItem, index)"
                          @keydown.enter="$emit('setAddress', addressItem, index)"
                          @keydown.prevent.down="$event.target.nextElementSibling.focus()"
                          @keydown.up="$event.target.previousElementSibling.focus()"
                  >
                    {{ addressItem.full_address }}
                  </button>
                </div>
              </div>
            </div>
            <div class="col-4 col-lg-2 col-xl-2 col-md-2 pr-1 px-md-1 px-lg-1 px-xl-1">
              <div class="select-wrap">
                <label>Floor</label>
                <input v-model="address.floor"
                       type="text"
                       class="form-control"
                       :disabled="inactiveStatus || !hasAccess"
                       @keyup="$emit('toggleEditField')"
                />
              </div>
            </div>
            <div class="col-4 col-lg-2 col-xl-2 col-md-2 pl-1 px-md-1 px-lg-1 px-xl-1">
              <div class="select-wrap">
                <label>Apt.</label>
                <input v-model="address.apartment"
                       type="text"
                       class="form-control"
                       :disabled="inactiveStatus || !hasAccess"
                       @keyup="$emit('toggleEditField')"
                />
              </div>
            </div>
            <div class="col-1 text-center px-1">
              <template v-if="activeStatus">
                <div v-if="index !== 0"
                     :class="{disabled: inactiveStatus || !hasAccess}"
                     @click="switchRoute('switchRoute', 'up', index)"
                >
                  <span class="btn-arrow-up" />
                </div>
                <div v-if="index < addresses.length - 1"
                     :class="{disabled: inactiveStatus || !hasAccess}"
                     @click="switchRoute('switchRoute', 'down', index)"
                >
                  <span class="btn-arrow-down" />
                </div>
              </template>
            </div>
            <div class="col-1 pt-3">
              <div class="btn-clear"
                   :class="{disabled: inactiveStatus || !hasAccess}"
                   @click="removeAddress('removeAddress', index)"
                   v-if="$_can(permission) && activeStatus"
              >
                <span class="mod-icon-clear" />
              </div>
            </div>
          </div>
          <error-field :errors="errors" :field="`addresses.${index}.postal_code`" />
        </div>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-1" />
      <div class="col-12 col-xl-11 col-lg-11 col-md-11 pl-4 pl-md-0 pl-lg-0 pl-xl-0">
        <button class="btn add-button"
                type="button"
                :class="{disabled: inactiveStatus || !hasAccess}"
                :disabled="inactiveStatus || !hasAccess"
                @click="$emit('addAddress', 1)"
                v-if="$_can(permission) && activeStatus"
        >
          <span><span class="mod-icon-add" /></span>Add address
        </button>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-10 select-wrap">
        <label class="d-inline-block">
          Location notes
        </label>
        <textarea
          v-model="data.address_note"
          :disabled="inactiveStatus || !hasAccess"
          class="form-control mb-2 input-address-note"
          @keyup="$emit('toggleEditField')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import _ from 'lodash';

export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    showDropdown: {
      type: Array,
      default: () => [],
    },
    permission: {
      type: String,
      default: '',
    },
    errors: {
      type: Object,
      default: () => {},
    },
    hasAccess: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
  data: () => ({
    addresses: [],
  }),
  computed: {
    inactiveStatus() {
      return (
        this.data.status &&
        (this.data.status.name === 'Canceled' ||
          this.data.status.name === 'Completed' ||
          this.data.status.name === 'Closed' ||
          this.data.status.name === 'No Availability' ||
          this.data.status.name === 'Booked' ||
          this.data.status.name === 'Final follow up')
      );
    },
    activeStatus() {
      return (
        this.data.status &&
        this.data.status.name !== 'Canceled' &&
        this.data.status.name !== 'Completed' &&
        this.data.status.name !== 'Closed' &&
        this.data.status.name !== 'No Availability' &&
        this.data.status.name !== 'Booked'
      );
    },
    canSwitchRoute() {
      return this.activeStatus || this.hasAccess;
    },
  },
  methods: {
    toggleEditField() {
      if (this.hasAccess) {
        this.$emit('toggleEditField');
      }
    },
    switchRoute(...args) {
      if (this.hasAccess) {
        this.$emit(...args);
      }
    },
    removeAddress(eventToEmit, arg) {
      if (this.hasAccess) {
        this.$emit(eventToEmit, arg);
      }
    },
    getAddressData: _.debounce(function call(streetName, index) {
      if (streetName.length < 3) {
        this.$set(this.showDropdown, index, false);
      } else {
        if (typeof this.source !== typeof undefined) {
          this.source.cancel('Operation canceled due to new request.');
        }
        this.source = axios.CancelToken.source();
        this.$set(this.showDropdown, index, true);
        this.$emit('toggleEditField');
        axios
          .get(
            `autocomplete?address=${encodeURIComponent(streetName)}`,
            // cancel token used by axios
            { cancelToken: this.source.token },
          )
          .then(res => {
            this.$set(this.addresses, index, res.data.data);
          })
          .catch(err => {
            if (!axios.isCancel(err)) {
              this.errors.record(err.response.data.error);
            }
          });
      }
    }, 500),
  },
};
</script>

<style>
.input-address-note {
  margin-top: 3px !important;
  padding-top: 0px !important;
  min-height: 50px;
  max-height: 120px;
}
</style>



// WEBPACK FOOTER //
// src/components/JobsLeadsAddresses.vue